import { useLiveData, useService, useServices } from '@toeverything/infra';

import { AppSidebarService } from '../../services/app-sidebar';
import {
  navHeaderLogoClipStyle,
  navHeaderLogoStyle,
  navHeaderStyle,
} from '../index.css';
import { SidebarSwitch } from './sidebar-switch';
import { WorkspaceService } from '@affine/core/modules/workspace';
import { WorkbenchService } from '@affine/core/modules/workbench';

export const WENXIAOBAI_CONVERSATION_LOGO_URL =
  'https://wy-static.wenxiaobai.com/wenxiaobai-web/production/3.16.9/conversationList/logo.png';

export const WENXIAOBAI_CONVERSATION_LOGO_SRC_SET = `${WENXIAOBAI_CONVERSATION_LOGO_URL} 1x, ${WENXIAOBAI_CONVERSATION_LOGO_URL} 2x`;

export const SidebarHeader = () => {
  const appSidebarService = useService(AppSidebarService).sidebar;
  const open = useLiveData(appSidebarService.open$);
  const { workbenchService, workspaceService } = useServices({
    WorkbenchService,
    WorkspaceService,
  });
  const workbench = workbenchService.workbench;
  const handleOpenHome = () => {
    workbench.openDoc('home');
    workspaceService.workspace.eventBus.emit(
      { id: 'chat.created', _type: 'chat.created' },
      {}
    );
  };
  return (
    <div className={navHeaderStyle} data-open={open}>
      <div
        onClick={handleOpenHome}
        className={navHeaderLogoClipStyle}
        data-open={open}
      >
        <img
          className={navHeaderLogoStyle}
          src={WENXIAOBAI_CONVERSATION_LOGO_URL}
          srcSet={WENXIAOBAI_CONVERSATION_LOGO_SRC_SET}
          width={87}
          height={30}
          alt="logo"
        />
      </div>
      <SidebarSwitch show={open} />
    </div>
  );
};

export * from './sidebar-switch';
